module.exports = __webpack_public_path__ + "bbb63055892efecdace7f3ddefb1b1fe.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/avanga_logo.png
// module id = 679
// module chunks = 0